export {};
//# sourceMappingURL=genericHTTPAPI.js.map